import InputField from "components/FormFields/InputField";
import { PayoutMethodEnum } from "enum/common";
import React, { useEffect, useMemo } from "react";
import ReactSelect from "react-select";
import { useLazyCityListQuery } from "store/apis/cityListApi";
import { useLazyStateListQuery } from "store/apis/stateListApi";
const countryCode = "CA";
const CanadianEftPersonalForm: React.FC<{ formikRef: any }> = ({
  formikRef,
}) => {
  const [fetchStates, { data: states }] = useLazyStateListQuery();

  const [fetchCities, { data: cities }] = useLazyCityListQuery();

  const stateOptions = useMemo(() => {
    return states?.result?.length
      ? states?.result?.map(({ name, isoCode }) => ({
          name: name,
          value: isoCode,
        }))
      : [];
  }, [states]);

  const cityOptions = useMemo(() => {
    return cities?.result?.length
      ? cities?.result?.map(({ name }) => ({
          name: name,
          value: name,
        }))
      : [];
  }, [cities]);

  const { handleSubmit, setFieldValue, values, touched, errors } = formikRef;

  useEffect(() => {
    setFieldValue("country", { label: "Canada", value: "CA" });
    fetchStates({ countryCode: "CA" });
  }, []);

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col"
      id={`${PayoutMethodEnum.CANADA_EFT}-personal`}
    >
      <div className="text-darkBlue text-sm font-semibold mb-3">
        Step 1: Basic Information
      </div>
      <div className="flex-1 ">
        <InputField
          onChange={(e) => {
            setFieldValue("firstName", e.target.value);
          }}
          value={values?.firstName}
          label={"First Name"}
          placeholder="Enter First Name"
          id={""}
          error={touched.firstName && errors.firstName}
        />
        <InputField
          onChange={(e) => {
            setFieldValue("lastName", e.target.value);
          }}
          value={values?.lastName}
          label={"Last Name"}
          placeholder="Enter Last Name"
          id={""}
          error={touched.lastName && errors.lastName}
        />
        <div>
          <InputField
            onChange={(e) => {
              setFieldValue("address1", e.target.value);
            }}
            value={values?.address1}
            label={"Street Address"}
            placeholder="Enter Street Address"
            id={""}
            error={touched.address1 && errors.address1}
          />
          <div className="mb-6">
            <div className="block mb-2 text-sm font-medium text-gray-900 text-opacity-80">
              Select State
            </div>
            <ReactSelect
              getOptionLabel={(option) => option?.name || ""}
              value={values.state}
              className="mt-1"
              isDisabled={false}
              isSearchable={true}
              autoFocus={false}
              placeholder="Select State"
              isMulti={false}
              closeMenuOnSelect
              options={stateOptions}
              onChange={(selectedOption: any) => {
                setFieldValue("state", selectedOption);
                setFieldValue("city", null);
                fetchCities({
                  countryCode: countryCode,
                  stateCode: selectedOption.value,
                });
              }}
            />
            <>
              {touched.state && errors.state && (
                <div className="pt-1 pl-1 text-sm text-red-600">
                  {/* @ts-ignore removing type error for nested object */}
                  {errors?.state?.name || ""}
                </div>
              )}
            </>
          </div>
        </div>
        <div className="mb-6">
          <div className="block mb-2 text-sm font-medium text-gray-900 text-opacity-80">
            Select City
          </div>
          <ReactSelect
            getOptionLabel={(option) => option?.name || ""}
            value={values.city}
            className="mt-1"
            isDisabled={false}
            isSearchable={true}
            autoFocus={false}
            placeholder="Select City"
            isMulti={false}
            closeMenuOnSelect
            options={cityOptions}
            onChange={(selectedOption: any) => {
              setFieldValue("city", selectedOption);
            }}
          />
          <>
            {touched.city && errors.city && (
              <div className="pt-1 pl-1 text-sm text-red-600">
                {/* @ts-ignore removing type error for nested object */}
                {errors?.city?.name || ""}
              </div>
            )}
          </>
        </div>
        <InputField
          onChange={(e) => {
            setFieldValue("zipCode", e.target.value);
          }}
          value={values?.zipCode}
          label={"Zipcode"}
          placeholder="Enter Zipcode"
          id={""}
          error={touched.zipCode && errors.zipCode}
        />
      </div>
    </form>
  );
};

export default CanadianEftPersonalForm;
